import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: "#about", label: "Cégünkről" },
    { href: "#services", label: "Szolgáltatások" },
    { href: "#founder", label: "Rólunk" },
    { href: "#survey", label: "Kapcsolat" },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? "bg-white/95 backdrop-blur-md shadow-lg py-3" 
          : "bg-transparent py-5"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#"
            data-testid="logo-link"
            className="flex items-center"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img 
              src="/images/logo.png" 
              alt="Vályog-Mester Logo" 
              className="h-28 w-auto"
              style={{ 
                filter: 'invert(1) brightness(0.3) sepia(1) saturate(5) hue-rotate(190deg)'
              }}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-2">
            {navLinks.map((link) => (
              <button
                key={link.href}
                data-testid={`nav-${link.href.replace("#", "")}`}
                onClick={() => scrollToSection(link.href)}
                className="text-slate-600 hover:text-blue-900 hover:bg-blue-50 px-5 py-2.5 rounded-full font-medium transition-all"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+36309669528"
              data-testid="header-phone"
              className="flex items-center gap-2 text-slate-600 hover:text-blue-900 font-medium transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>+36 30 966 9528</span>
            </a>
            <button
              data-testid="header-cta-btn"
              onClick={() => scrollToSection("#survey")}
              className="bg-blue-900 text-white px-6 py-3 font-bold rounded-full hover:bg-blue-800 transition-all shadow-button hover:scale-105 active:scale-95"
            >
              Ingyenes felmérés
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-blue-900 hover:bg-blue-50 rounded-full transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 shadow-lg mt-3">
          <div className="px-6 py-6 space-y-2">
            {navLinks.map((link) => (
              <button
                key={link.href}
                data-testid={`mobile-nav-${link.href.replace("#", "")}`}
                onClick={() => scrollToSection(link.href)}
                className="block w-full text-left text-slate-600 hover:text-blue-900 hover:bg-blue-50 font-medium py-3 px-4 rounded-2xl transition-colors"
              >
                {link.label}
              </button>
            ))}
            <div className="pt-4 border-t border-slate-100 mt-4">
              <a
                href="tel:+36309669528"
                className="flex items-center gap-2 text-blue-900 font-medium mb-4 px-4"
              >
                <Phone className="w-4 h-4" />
                <span>+36 30 966 9528</span>
              </a>
              <button
                data-testid="mobile-cta-btn"
                onClick={() => scrollToSection("#survey")}
                className="w-full bg-blue-900 text-white px-6 py-4 font-bold rounded-full hover:bg-blue-800 transition-all"
              >
                Ingyenes felmérés
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
